<div class="takeda-radio">
  <label (click)="select()">
    <div class="radio-button" [class.checked]="isChecked">&nbsp;</div>
    <div class="label-text">{{ label }}</div>
  </label>
</div>
